import { Image, Modal } from "antd";
import React, { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
//import baseConfig from "../../../baseconfig.json";
import { shouldShowComponent } from "../../../utils/componentVisibility";

const AddLoginFields = (props) => {
  const shouldShow = shouldShowComponent(config.project, "AddLoginFields");

  if (!shouldShow) {
    return null; // Do not render if the condition is not met
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: 'space-between',
          textAlign: "center",
          paddingTop: "8px",
          gap: '15px'
        }}
      >
        {" "}
        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/google-play-btn.png")}
          onClick={() => {
            props.handleGoogleStates();

          }}
        ></Image>

        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/app-store-btn.png")}
          onClick={() => {
            props.handleAppleStates();
          }}
        ></Image>

        <Image
          style={{ cursor: "pointer" }}
          src={require("../../../assets/images/app-images/app-gallery-btn.png")}
          onClick={() => {
            props.handleAppGalleryStates();
          }}
        ></Image>
      </div>
    </>
  );
};

AddLoginFields.contextType = StoreContext;
export default observer(withRouter(AddLoginFields));
